/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The statement of interest exactly as the resident will submit it (`terms` and `accepted` only; TXN-3478).
 * @export
 * @interface HomeownershipLoiBlock
 */
export interface HomeownershipLoiBlock {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLoiBlock
     */
    text: string;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipLoiBlock
     */
    version: number;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipLoiBlock
     */
    contractDeadlineDays?: number;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLoiBlock
     */
    contractDeadlineDate?: string;
}

/**
 * Check if a given object implements the HomeownershipLoiBlock interface.
 */
export function instanceOfHomeownershipLoiBlock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function HomeownershipLoiBlockFromJSON(json: any): HomeownershipLoiBlock {
    return HomeownershipLoiBlockFromJSONTyped(json, false);
}

export function HomeownershipLoiBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipLoiBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
        'version': json['version'],
        'contractDeadlineDays': !exists(json, 'contract_deadline_days') ? undefined : json['contract_deadline_days'],
        'contractDeadlineDate': !exists(json, 'contract_deadline_date') ? undefined : json['contract_deadline_date'],
    };
}

export function HomeownershipLoiBlockToJSON(value?: HomeownershipLoiBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'version': value.version,
        'contract_deadline_days': value.contractDeadlineDays,
        'contract_deadline_date': value.contractDeadlineDate,
    };
}

